<script>
import VideoRectangleTile from './VideoRectangleTile';
import VideoSquareTile from './VideoSquareTile';
import VideoModal from './VideoModal';
import VideoLoading from './VideoLoading';
export default {
  name: 'VideoTile',
  components: {
    VideoRectangleTile,
    VideoSquareTile,
    VideoModal,
    VideoLoading,
  },
  props: {
    videoId: {
      type: String,
      required: true,
    },
    videoTitle: {
      type: String,
      required: true,
    },
    videoImageUrl: {
      type: String,
      required: true,
    },
    videoDuration: {
      type: String,
      required: true,
    },
    videoPublishedAt: {
      type: String,
      required: true,
    },
    tileType: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isVideoModalActive: false,
    };
  },
  methods: {
    toggleVideoModal(value) {
      this.isVideoModalActive = value;
    },
  },
};
</script>


<template>
  <div class="tile-wrap">
    <a v-if="tileType == 'square'" :href="link">
      <VideoSquareTile
        :key="`video-square-tile-${videoId}`"
        :video-id="videoId"
        :video-title="videoTitle"
        :video-image-url="videoImageUrl"
        :video-duration="videoDuration"
        :video-published-at="videoPublishedAt"
      />
    </a>
    <a v-else-if="tileType == 'rectangle'" :href="link">
      <VideoRectangleTile
        :key="`video-rectangle-tile-${videoId}`"
        :video-id="videoId"
        :video-title="videoTitle"
        :video-image-url="videoImageUrl"
        :video-duration="videoDuration"
        :video-published-at="videoPublishedAt"
      />
    </a>
    <!-- Show Video Modal when tile is clicked -->
    <VideoModal
      v-if="isVideoModalActive"
      :video-id="videoId"
      :video-title="videoTitle"
      @closeModal="toggleVideoModal(false)"
    />
  </div>
</template>
